var _defs, _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBabylon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 221.84 256.19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#e0684b;}.cls-3{fill:#bb464b;}.cls-4{fill:#e0ded8;}.cls-5{fill:#d5d2ca;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M 110.92,0.01 0,64.01 v 128.11 l 110.92,64.07 110.92,-64 V 64.04 Z",
    id: "path830"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "264.5,128.09 299.22,148.14 332.62,128.85 297.9,108.81 ",
    id: "polygon832",
    transform: "translate(-110.78,-64.81)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "221.7,64.81 110.78,128.85 144.18,148.14 255.09,84.1 ",
    id: "polygon834",
    transform: "translate(-110.78,-64.81)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "256.41,212.94 221.7,192.89 186.98,212.94 221.7,232.98 ",
    id: "polygon836",
    transform: "translate(-110.78,-64.81)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "221.7,282.41 144.18,237.65 144.18,148.14 110.78,128.85 110.78,256.93 221.7,320.97 332.62,256.93 332.62,128.85 299.22,148.14 299.22,237.65 ",
    id: "polygon838",
    transform: "translate(-110.78,-64.81)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "186.98,212.94 221.7,192.89 256.41,212.94 256.41,172.85 221.7,152.81 186.98,172.85 ",
    id: "polygon840",
    transform: "translate(-110.78,-64.81)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "256.41,212.94 221.7,232.98 221.7,282.41 299.22,237.65 299.22,148.14 256.41,172.85 ",
    id: "polygon842",
    transform: "translate(-110.78,-64.81)"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "186.98,212.94 221.7,232.98 221.7,282.41 144.18,237.65 144.18,148.14 186.98,172.85 ",
    transform: "translate(-110.78,-64.81)"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "264.5,128.09 299.22,148.14 256.41,172.85 221.7,152.81 186.98,172.85 144.18,148.14 255.09,84.1 297.9,108.81 ",
    transform: "translate(-110.78,-64.81)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBabylon);
export default __webpack_public_path__ + "static/media/babylon.830df0841d4d0663950f622bad73e04f.svg";
export { ForwardRef as ReactComponent };